<template>
    <CRow>
        <CCol col>
            <div id="spot-summary">
                <div class="market-price-padding"></div>
                <!--<ejs-datepicker ref="dateObj" :placeholder="waterMark" v-model="dateVal" :format="dateFormat" :focus='onFocus' :firstDayOfWeek='1' :max='maxVal' width=180></ejs-datepicker>-->
                <div style="width:100%; height: 80vh;">
                    <ejs-grid ref='grid' :dataSource="spotSummaryData" :allowFiltering='true' :allowPaging="true"
                              :allowResizing='true' :allowExcelExport='true'
                              :allowReordering='true' :allowSorting='true' :excelQueryCellInfo='excelQueryCellInfo'
                              :editSettings='editSettings' :pageSettings='pageSettings' :actionBegin='actionBegin' :queryCellInfo='queryCellInfo'
                              :actionComplete='actionComplete' :actionFailure="actionFailure" :query='query' :filterSettings='filterOptions' width="100%" height="100%" :dataBound='dataBound'>
                        <e-columns>
                            <e-column field='spotPricingId' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>

                            <e-column field='ricName' headerText='Identifier' textAlign='Left' visible="true" width=150 type="string"></e-column>
                            <e-column field='stateName' headerText='Country' textAlign='Left' :allowEditing="false" width=150 type="string"></e-column>
                            <e-column field='priceAreaName' headerText='Price Area' textAlign='Left' :allowEditing="false" width=150 type="string"></e-column>
                            <e-column field='utilityTypeName' headerText='Commodity' textAlign='Left' :allowEditing="false" width=150 type="string"></e-column>
                            <e-column field='productName' headerText='Product' textAlign='Left' width=180 type="string" :allowEditing="false"></e-column>
                            <e-column field='TradingUnitPreview' headerText='Trading Unit' textAlign='Left' :allowEditing="false" :allowFiltering="true" width=150 type="string"></e-column>
                            <e-column field='price' :disableHtmlEncode='false' headerText='Todays Price' textAlign='Left' width=180 type="number" format="n3" :allowEditing="false" :allowFiltering="false"></e-column>
                            <e-column field='mtdAvg' :disableHtmlEncode='false' headerText='MTD Avg' textAlign='Left' width=180 type="number" format="n3" :allowEditing="false" :allowFiltering="false"></e-column>
                            <e-column field='weekAvg' :disableHtmlEncode='false' headerText='Week avg' textAlign='Left' width=180 type="number" format="n3" :allowEditing="false" :allowFiltering="false"></e-column>
                            <e-column field='avg30D' :disableHtmlEncode='false' headerText='30D Avg' textAlign='Left' width=180 type="number" format="n3" :allowEditing="false" :allowFiltering="false"></e-column>
                            <e-column field='yearAvg' :disableHtmlEncode='false' headerText='Year Avg' textAlign='Left' width=180 type="number" format="n3" :allowEditing="false" :allowFiltering="false"></e-column>
                            <e-column field='VsYesterdayPct' :disableHtmlEncode='false' headerText='vs Yesterday(%)' textAlign='Left' width=180 type="number" format="n2" :allowEditing="false" :allowFiltering="false"></e-column>
                            <e-column field='VsMtdAvgPct' :disableHtmlEncode='false' headerText='vs MTD avg(%)' textAlign='Left' width=180 type="number" format="n2" :allowEditing="false" :allowFiltering="false"></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { DropDownList, DropDownListPlugin } from "@syncfusion/ej2-dropdowns";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import authToken from '../../../common/authToken';
    import urls from '../../../common/urls';
    import SyncHelper from '../../../common/syncfusion';
    import gridOptions from '../../../common/gridOptions';
    import dates from '../../../common/dates';
    import apis from '../../../common/network';
    import { DatePickerPlugin, DatePicker } from '@syncfusion/ej2-vue-calendars';
    import store from '../../../store';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    Vue.use(DatePickerPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(GridPlugin);
    let spotRicObj, spotRicElem, datePickerObj, elem;

    export default {
        components: {
        },
        data() {
            return {
                store: store,
                maxVal: new Date(),
                waterMark: 'Select a date',
                dateVal: dates.addDays(new Date(), -1),
                format: "dd/MM/yyyy",
                dateFormat: 'dd/MM/yyyy',

                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } },
                numericParams: {
                    params: {
                        validateDecimalOnType: true,
                        decimals: 4,
                        format: "n4"
                    }
                },
                spotSummaryData: this.$store.state.permissions["Permissions.SpotPricing.View"] ? SyncHelper.getDataManager("SpotPricing/GetSpotSummary") : [],
                dpParams: {
                    create: function () {
                        elem = document.createElement('input');
                        return elem;
                    },
                    read: () => {
                        return datePickerObj.value;
                    },
                    destroy: () => {
                        datePickerObj.destroy();
                    },
                    write: (args) => {
                        datePickerObj = new DatePicker({
                            value: new Date(args.rowData[args.column.field]),
                            floatLabelType: 'Always',
                            format: 'dd/MM/yyyy',
                            //sets the max.
                            max: dates.addDays(new Date(), -1),
                            placeholder: 'Settlement Date',
                            firstDayOfWeek: 1
                        });
                        datePickerObj.appendTo(elem);
                    }
                },
                pageSettings: { pageSizes: [10, 20, 50, 100], pageSize: 100, pageCount: 4 },
                filterOptions: gridOptions.filterSettings,

            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
            this.checkPermissionOnUser();
        },
        methods: {

            actionBegin(args) {
                gridOptions.actionBegin(args);

            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);


            },
            actionFailure(args) {
                gridOptions.actionFailure(args)
                hideSpinner(document.getElementById('mainSpinner'));
            },
            addHeaders: function (args) {
                args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
            },

            onFocus: function (args) {
                this.$refs.dateObj.show();
            },
            queryCellInfo(args) {
                if (args.column.field === 'tradingUnitName') {
                    args.cell.textContent = args.data.currencySymbol + '/' + args.data.tradingUnitName;
                }
                if (args.column.headerText === 'Log Date') {
                    args.cell.textContent = this.formatDate(args.data['logDate']);
                }
                if (args.column.field === 'VsYesterdayPct' || args.column.field === 'VsMtdAvgPct') {
                    var raw = args.data[args.column.field];
                    if (raw === undefined) {
                        var camelKey = args.column.field.charAt(0).toLowerCase() + args.column.field.slice(1);
                        raw = args.data[camelKey];
                    }
                    var value = parseFloat(raw);

     

                    if (!isNaN(value)) {
                        args.cell.textContent = value.toFixed(2) + '%';
                        args.cell.style.setProperty('color', value < 0 ? 'red' : 'green', 'important');
                        args.cell.style.setProperty('font-weight', '600', 'important');
                    }
                
                }
            },
            dataBound() {
                //var grid = this.$refs.grid.ej2Instances;
                //var rows = grid.getCurrentViewRecords();
                //var symbol = (rows && rows.length && rows[0].currencySymbol) ? rows[0].currencySymbol : '\u20AC';
                //var priceFields = ['price', 'mtdAvg', 'weekAvg', 'avg30D', 'yearAvg'];
                //priceFields.forEach(function (field) {
                //    var column = grid.getColumnByField(field);
                //    if (column) {
                //        var label = column.headerText.split('<br')[0];
                //        grid.getColumnHeaderByField(field).querySelector('.e-headertext').innerHTML =
                //            label + '<br/>(' + symbol + '/MWh)';
                //    }
                //});
            },
            convertUTCDateToLocaDate(dateString) {
                const date = new Date(dateString)
                var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
                return newDate.toLocaleDateString();
            },
            formatDate(dateString) {
                const date = new Date(dateString)
                return date.toLocaleDateString();
            },
            excelQueryCellInfo: function (args) {
                if (args.column.headerText === 'Log Date') {
                    args.cell.value = this.convertUTCDateToLocaDate(args.data['logDate']);
                }
                if (args.column.field === 'tradingUnitName') {
                    args.value = args.data.currencySymbol + '/' + args.data.tradingUnitName;
                }
            },
            checkPermissionOnUser: function () {

                if (!this.$store.state.permissions["Permissions.MarketWidgetsAndGraphs.Update"]) {

                    this.toolbar = ['Add', 'Edit', 'Delete'];
                    document.getElementById("spotModalTarget").style.display = "none";
                }

            },
        },
        computed: {
            query: function () {

                return new Query().addParams("date", this.dateVal.toISOString().split('T')[0]);

            }
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    };


</script>
<style>


    #spot-summary .e-grid .e-headercelldiv {
        height: auto;
        line-height: 1.3;
    }

    #spot-summary .e-grid .e-headertext {
        white-space: normal;
        text-align: left;
        display: block;
        width: 100%;
    }

    .market-price-padding {
        padding-top: 30px;
    }
</style>
